import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
	name: 'truncateNumber',
})
export class TruncateNumberPipe implements PipeTransform {
	transform(value: number, decimalPlaces = 2): string {
		if (value === null || value === undefined) {
			return ''
		}
		const parts = value.toString().split('.')
		if (parts.length === 1) {
			return parts[0] // No decimal part
		}
		const integerPart = parts[0]
		const fractionalPart = parts[1]
		if (fractionalPart.length <= decimalPlaces) {
			return value.toString() // Already has fewer or equal decimal places
		}
		return `${integerPart}.${fractionalPart.substring(0, decimalPlaces)}`
	}
}
